export const style = {
  container: {
    backgroundColor: "var(--neutral-100)",
  },
  mainContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: {
      xs: "100%",
      md: "60vh",
    },
  },
  innerContainer: {
    overflowY: "auto",
    borderRight: "0.1rem solid var(--gray-20)",
    width: {
      xs: "100%",
      md: "50%",
      lg: "50%",
    },
    borderRadius: { xs: "0rem", lg: "1.2rem" },
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "1.6rem",
    backgroundColor: "var(--neutral-100)",
    width: "100%",
    position: "sticky",
    top: 0,
    zIndex: 100,
  },
  headerInnerContainer: {
    display: "flex",
    alignItems: "center",
  },
  accordion: {
    boxShadow: "none",
    borderRadius: "0rem",
    paddingRight: "1.2rem",
    "&.Mui-expanded": {
      margin: 0,
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  accordionSummary: {
    padding: "0rem",
    margin: "0rem",
  },
  accordionDetails: {
    padding: "0rem",
  },
  accordionSummaryIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "2.4rem",
    height: "2.4rem",
    borderRadius: "1.8rem",
    background: "var(--gray-400)",
  },
  availabilitySlotBookedContainer: {
    overflowY: "auto",
    borderRight: "0.1rem solid var(--gray-20)",
    width: {
      xs: "100%",
      md: "50%",
    },
    display: {
      xs: "none",
      md: "block",
      lg: "block",
    },
    borderRadius: { xs: "0rem", lg: "1.2rem" },
  },
  headerText: {
    color: "var(--black-900)",
    fontSize: "1.6rem",
    fontWeight: "500",
  },
  createActionContainer: {
    display: { xs: "block", lg: "none" },
  },
};
